
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { environment } from '@environments/environment';

@Injectable()
export abstract class HttpService {
  storageService = inject(StorageService);
  http = inject(HttpClient);
  organizationName: string = environment.organizationName || 'default';

  protected get(url: string, params?: any): Observable<any> {
    return this.http
      .get(url, params)
      .pipe(catchError((error) => this.handleError(error)));
  }

  protected post(url: string, params?: any, options?: any): Observable<any> {
    return this.http.post(url, params, options);
    // .pipe(catchError(error => this.handleError(error)));
  }

  protected put(url: string, params?: any, options?: any): Observable<any> {
    return this.http
      .put(url, params, options)
      .pipe(catchError((error) => this.handleError(error)));
  }

  protected delete(url: string, options?: any): Observable<any> {
    return this.http
      .delete(url, options)
      .pipe(catchError((error) => this.handleError(error)));
  }

  protected deleteRaw(url: string, options?: any): Observable<any> {
    return this.http.delete(url, options);
  }

  protected patch(url: string, params?: any, options?: any): Observable<any> {
    return this.http
      .patch(url, params, options)
      .pipe(catchError((error) => this.handleError(error)));
  }

  protected handleError(error: HttpErrorResponse | any) {
    let errMsg: string;

    // Con responseType 'text' (los DELETE sin cuerpo) el error llega como texto JSON sin interpretar.
    let body = error?.error;
    if (typeof body === 'string') {
      try { body = JSON.parse(body); } catch { /* no era JSON: se deja el texto */ }
    }
    const nestMessage = Array.isArray(body?.message)
      ? body.message.join(' · ')
      : typeof body?.message === 'string'
        ? body.message
        : null;

    if (
      error instanceof HttpErrorResponse &&
      error.error &&
      error.error.errors
    ) {
      const b = error.error || '';
      const err = b.errors[0].message || JSON.stringify(b);
      errMsg = `${error.status} - ${error.statusText || ''}. ${err}`;
    } else if (nestMessage) {
      // Excepciones de NestJS: { message, error, statusCode }
      errMsg = nestMessage;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    const err = new Error(errMsg);
    (err as any).status = error?.status;
    return throwError(() => err);
  }

  protected createHeaders() {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`,
        'X-Organization-Name': this.organizationName,
      }),
    };
    return options;
  }
}
